import { cn } from '@/lib/utils';
import { Image } from './image';
import { DynamicPopover } from './dynamic-popover';

export interface ImageHoverPreviewProps {
  url: string;
  children: React.ReactNode;
  sideOffset?: number;
  className?: string;
  tag?: string;
}

export const ImageHoverPreview = ({
  url,
  children,
  sideOffset = 4,
  tag,
  className
}: ImageHoverPreviewProps) => {
  return (
    <DynamicPopover
      side="bottom"
      align="center"
      sideOffset={sideOffset}
      mode="hover"
      triggerClassName="w-full h-full"
      triggerHidden={false}
      className={cn(
        "relative w-[155px] h-[268px] bg-white [box-shadow:0px_4.6px_9.1px_rgba(0,_0,_0,_0.2)] rounded-[12px]",
        className
      )}
      trigger={
        children
      }
    >
      <Image
        src={url}
        alt="Preview"
        className="w-full h-full rounded-[8px] object-cover"
      />
      {tag && <span className='absolute bottom-1.5 left-1.5 py-0.5 px-1 text-xs text-white rounded-[4px] bg-[rgba(0,0,0,0.3)]'>{tag}</span>}
    </DynamicPopover>
  );
};